import { render, staticRenderFns } from "./ResultsPage.vue?vue&type=template&id=3fa7c7e0"
import script from "./ResultsPage.vue?vue&type=script&lang=ts"
export * from "./ResultsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports